module.exports = __webpack_public_path__ + "img/image_003.d6546615.jpeg";